import "leaflet/dist/leaflet.css";
import './App.css';
import { LeafletMap } from './components/Map/LeafletMap';
import "leaflet/dist/leaflet.css"

// This is a hack to get around Strict-mode for react causing double renders in development mode
export var firstRenderHasRun = false;
export function confirmFirstRender() {
    firstRenderHasRun = true;
}

function App() {

  return (
    <>
      <LeafletMap />
                  
    </>
  );
}

export default App;